import { useQuery } from '@tanstack/react-query';
import DefaultPricingEntity from 'Models/Entities/DefaultPricingEntity';
import { fetchDefaultPricing } from 'Services/Api/_HumanWritten/DefaultPricingApi';
import { defaultPricingKeys } from './defaultPricingKeys';

export const useDefaultPricingDetail = (id?: string) => {
	return useQuery<DefaultPricingEntity, Error>({
		queryKey: defaultPricingKeys.detail(id!),
		queryFn: () => fetchDefaultPricing(id!),
		enabled: !!id,
	});
};
